/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elastic_Gallery_Item_02_AltInputs */

const en_elastic_gallery_item_02_alt = /** @type {(inputs: Elastic_Gallery_Item_02_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brutalist concrete architecture`)
};

const ar_elastic_gallery_item_02_alt = /** @type {(inputs: Elastic_Gallery_Item_02_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عمارة خرسانية وحشية`)
};

const bn_elastic_gallery_item_02_alt = /** @type {(inputs: Elastic_Gallery_Item_02_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ব্রুটালিস্ট কংক্রিট আর্কিটেকচার`)
};

const de_elastic_gallery_item_02_alt = /** @type {(inputs: Elastic_Gallery_Item_02_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brutalistische Betonarchitektur`)
};

const es_elastic_gallery_item_02_alt = /** @type {(inputs: Elastic_Gallery_Item_02_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitectura brutalista de hormigón`)
};

const fr_elastic_gallery_item_02_alt = /** @type {(inputs: Elastic_Gallery_Item_02_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architecture brutaliste en béton`)
};

const pt_elastic_gallery_item_02_alt = /** @type {(inputs: Elastic_Gallery_Item_02_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitetura brutalista de concreto`)
};

const zh_elastic_gallery_item_02_alt = /** @type {(inputs: Elastic_Gallery_Item_02_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`野兽派混凝土建筑`)
};

const tr_elastic_gallery_item_02_alt = /** @type {(inputs: Elastic_Gallery_Item_02_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brütalist beton mimari`)
};

const ru_elastic_gallery_item_02_alt = /** @type {(inputs: Elastic_Gallery_Item_02_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бруталистическая бетонная архитектура`)
};

const pl_elastic_gallery_item_02_alt = /** @type {(inputs: Elastic_Gallery_Item_02_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brutalistyczna architektura betonowa`)
};

/**
* | output |
* | --- |
* | "Brutalist concrete architecture" |
*
* @param {Elastic_Gallery_Item_02_AltInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const elastic_gallery_item_02_alt = /** @type {((inputs?: Elastic_Gallery_Item_02_AltInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elastic_Gallery_Item_02_AltInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_elastic_gallery_item_02_alt(inputs)
	if (locale === "bn") return bn_elastic_gallery_item_02_alt(inputs)
	if (locale === "de") return de_elastic_gallery_item_02_alt(inputs)
	if (locale === "es") return es_elastic_gallery_item_02_alt(inputs)
	if (locale === "fr") return fr_elastic_gallery_item_02_alt(inputs)
	if (locale === "pt") return pt_elastic_gallery_item_02_alt(inputs)
	if (locale === "zh") return zh_elastic_gallery_item_02_alt(inputs)
	if (locale === "tr") return tr_elastic_gallery_item_02_alt(inputs)
	if (locale === "ru") return ru_elastic_gallery_item_02_alt(inputs)
	if (locale === "pl") return pl_elastic_gallery_item_02_alt(inputs)
	return en_elastic_gallery_item_02_alt(inputs)
});